import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import HumanResouceDashboard from 'images/HrDashboard.png';
export default function HumanResourceDetails() {
  return (
    <Box px={2} py={2}>
      <Typography variant='h5' align='center' mb={2}>{t('humanResourcedashboardText', { ns: ['home'] })}</Typography>
      <img src={HumanResouceDashboard} style={{ width: '100vw' }} />
    </Box>
  );
}